<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">
      {{(groupCustomerId ? 'title.enterprise_manage_group_customer' : 'title.enterprise_create_group_customer') |
      translate}} <span *ngIf="groupCustomerId">{{groupName}}</span>
      <small *ngIf="!groupCustomerId" class="form-text text-gray pull-left pb-2 float-right">(<span style="color: red;">*</span>) {{'form.info' |
        translate}}</small>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mt-3 mb-3 mat-card-content-contract-sm">
    <mat-accordion #accordion="matAccordion" [multi]="true" *ngIf="!this.isSMEHubAccount()">
      <mat-expansion-panel *ngIf="!groupCustomerId" expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'title.enterprise_create_group_customer' | translate}}
            <span *ngIf="groupCustomerId">&nbsp;{{groupCustomerName}}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #f="ngForm">
          <div class="row">
            <div class="col-lg-12 d-flex justify-content-center">
              <mat-form-field class="w-100">
                <input #focusInput matInput type="text" (focusout)="groupName = groupName.trim()"
                  [placeholder]="'enterprise_customer_management.lbl_group_customer_name' | translate" name="groupName"
                  [(ngModel)]="groupName" [formControl]="groupNameControl" autocomplete="off"
                  (change)="isFormChanging = true" maxlength="255" required />
                <button mat-button *ngIf="groupName" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="groupName=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="groupNameControl.invalid">
                  <span class="text-error">
                    {{'validation.group_customer_required' | translate}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 d-flex justify-content-center">
              <mat-form-field class="w-100">
                <textarea #focusInput matInput type="text" (focusout)="description = description.trim()"
                  [placeholder]="'enterprise_customer_management.lbl_group_customer_description' | translate"
                  name="description" [(ngModel)]="description" (change)="isFormChanging = true" autocomplete="off"
                  maxlength="255"></textarea>
                <button mat-button *ngIf="description" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="description=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- Danh sách khách hàng -->
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title border-0 m-0 p-0">
              <span class="mat-panel-title">{{'enterprise_customer_management.list_member_group_customer' |translate}}
              </span>
          </mat-panel-title>
      </mat-expansion-panel-header>
        <form *ngIf="!this.isSMEHubAccount()">
          <div class="row pt-2">
            <div class="col-sm-12 pb-1">
              <span class="mat-panel-title">
                {{'enterprise_customer_management.search_anh_add_customer' | translate}}
              </span>
            </div>
            <div class="col-sm-12" style="padding-right: 2rem !important;margin-bottom: 15px;">
              <div>
                <nz-input-group [nzSuffix]="suffixCustomerInput">
                  <input nz-input [(ngModel)]="inputCustomerValue"
                    (focusout)="inputCustomerValue = inputCustomerValue.trim()" (input)="onChangeCustomerSearch($event)"
                    [nzAutocomplete]="autoCustomerSearching" [ngModelOptions]="{ standalone: true }"
                    placeholder="{{'search_form.group_customer_search_placeholder' | translate}}" id="inputcustomer"
                    maxlength="200" nzServerSearch nzShowSearch nzAllowClear />
                  <nz-autocomplete #autoCustomerSearching>
                    <nz-auto-option *ngFor="let customer of filteredCustomerOptions"
                      (selectionChange)="autocompleteCustomerSelected($event, customer)" [nzValue]="''">
                      {{customer.certificateNo}} - {{customer.name}} <span *ngIf="customer.email">- {{customer.email}}</span></nz-auto-option>
                    <nz-auto-option *ngIf="filteredCustomerOptions.length == 0 && inputCustomerValue" nzDisabled
                      nzCustomContent>
                      <div style="padding: 6px; text-align: center; color: black">{{'messages.data_not_found' |
                        translate}}</div>
                    </nz-auto-option>
                    <nz-auto-option *ngIf="filteredCustomerOptions.length == 0 && inputCustomerValue" nzDisabled
                      nzCustomContent></nz-auto-option>
                  </nz-autocomplete>
                </nz-input-group>
                <ng-template #suffixCustomerInput>
                  <nz-spin *ngIf="nzCheckLoadingCustomer" nzSimple [nzIndicator]="indicatorCustomerInput"></nz-spin>
                </ng-template>
                <ng-template #indicatorCustomerInput>
                  <i class="nz-icon-font" nz-icon nzType="loading" style="font-size: 24px;"></i>
                </ng-template>
                <ng-template #suffixCustomerInput>
                  <span nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"
                    *ngIf="inputCustomerValue && !nzCheckLoadingCustomer" (click)="inputCustomerValue = ''"></span>
                </ng-template>
              </div>
            </div>
          </div>
        </form>
        <div class="row my-2" style="border-bottom: 1px solid #0000001f;margin: 0;">
          <div class="col-sm-8 p-0">
            <span class="mat-panel-title" style="border-bottom: none;">
              {{'enterprise_customer_management.list_customer' | translate}}
                ({{groupCustomerId ? (paginate.totalRow) : (dataSource.data.length)}})
            </span>
          </div>
          <div class="col-sm-4 p-0">
              <i class="fa fa-filter pull-right" (click)="openFilter()"
                style="margin-right: 7px; color: rgb(238 0 51); font-size: 18px; cursor: pointer;"
                matTooltip="{{ 'button.filter' | translate }}"
                aria-hidden="true"></i>
          </div>
        </div>
        <div class="mat-table-container pb-2">
          <mat-table [dataSource]="dataSource" width="100%">
            <!-- STT -->
            <ng-container matColumnDef="id">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_customer_management.table_headers.No' | translate}}</mat-header-cell>
              <mat-cell *matCellDef="let element"
              [ngClass]="{'backgroud-odd' : checkIndexOfElement(element), 'backgroud-even': !checkIndexOfElement(element)}"
              class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{groupCustomerId ? (paginate.no[dataSource.filteredData.indexOf(element)]) :
                (dataSource.filteredData.indexOf(element)+1)}}</mat-cell>
            </ng-container>

            <!-- Tên khách hàng -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef style="width: 25%;" class="mat-cell-non-boder-right-bottom">
                {{'enterprise_customer_management.table_headers.customer_name' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{element.name}}" matTooltipPosition="below"
              [ngClass]="{'backgroud-odd' : checkIndexOfElement(element), 'backgroud-even': !checkIndexOfElement(element)}"
                style="width: 35%;" class="mat-cell-non-boder-right-bottom">
                <span class="fix-width">{{element.name}}</span>
              </mat-cell>
            </ng-container>

            <!-- Số giấy tờ -->
            <ng-container matColumnDef="certificateNo">
              <mat-header-cell *matHeaderCellDef style="max-width: 20%;" class="mat-cell-non-boder-right-bottom">
                {{'enterprise_customer_management.group_customer_header.certificate_no' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 20%;" class="mat-cell-non-boder-right-bottom"
              [ngClass]="{'backgroud-odd' : checkIndexOfElement(element), 'backgroud-even': !checkIndexOfElement(element)}"
                matTooltip="{{element.certificateNo ? element.certificateNo : ''}}">
                <span class="fix-width">{{element.certificateNo}}
                </span>
              </mat-cell>
            </ng-container>

            <!-- email -->
            <ng-container matColumnDef="email">
              <mat-header-cell *matHeaderCellDef style="max-width: 20%;" class="mat-cell-non-boder-right-bottom">
                {{'enterprise_customer_management.group_customer_header.email' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 20%;" class="mat-cell-non-boder-right-bottom"
              [ngClass]="{'backgroud-odd' : checkIndexOfElement(element), 'backgroud-even': !checkIndexOfElement(element)}"
                matTooltip="{{element.email ? element.email : ''}}">
                <span class="fix-width">{{element.email}}
                </span>
              </mat-cell>
            </ng-container>

            <!-- Tác động -->
            <!-- Setting Column -->
            <ng-container matColumnDef="action" class="mat-column-symbol">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-bottom"
                style="max-width: 100px;">
                {{'headertable.action_cms' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-bottom"
              [ngClass]="{'backgroud-odd' : checkIndexOfElement(element), 'backgroud-even': !checkIndexOfElement(element)}"
                style="max-width: 100px;">
                <button mat-icon-button type="button" (click)="onClickIconDelete(element.id,element.name)" appTrackEvent="w.btn.dsnhomkh.qlkhtrongnhom.xoa"
                        *ngIf="!this.isSMEHubAccount()"
                  [disabled]="commonService.getIsLockedEnterprise()">
                  <i class="fa fa-trash" aria-hidden="true"
                    [ngClass]="{'disabled-locked': commonService.getIsLockedEnterprise()}"
                    matTooltip="{{'enterprise_customer_management.buttons.delete' | translate}}"></i>
                </button>
              </mat-cell>
            </ng-container>
            <!-- filter -->
            <!-- STT -->
            <ng-container matColumnDef="stt">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
              </mat-header-cell>
            </ng-container>

            <!-- Tên khách hàng -->
            <ng-container matColumnDef="filterName">
              <mat-header-cell *matHeaderCellDef style="width: 25%;" class="mat-cell-non-boder-right-bottom">
                <input style="width: 100%;" nz-input id="name" (focusout)="filterForm.name = filterForm.name.trim()"
                  (change)="onFilterCustomers()" [(ngModel)]="filterForm.name"
                  [placeholder]="'enterprise_customer_management.filter.customer_name' | translate">
              </mat-header-cell>
            </ng-container>

            <!-- Số giấy tờ -->
            <ng-container matColumnDef="filterCertificate">
              <mat-header-cell *matHeaderCellDef style="max-width: 20%;" class="mat-cell-non-boder-right-bottom">
                <input style="width: 100%;" nz-input id="certificateNo"
                  (focusout)="filterForm.certificateNo = filterForm.certificateNo.trim()" (change)="onFilterCustomers()"
                  [(ngModel)]="filterForm.certificateNo"
                  [placeholder]="'enterprise_customer_management.filter.certificateNo' | translate">
              </mat-header-cell>
            </ng-container>

            <!-- email -->
            <ng-container matColumnDef="filterEmail">
              <mat-header-cell *matHeaderCellDef style="max-width: 20%;" class="mat-cell-non-boder-right-bottom">
                <input style="width: 100%;" nz-input id="email" (focusout)="filterForm.email = filterForm.email.trim()"
                  (change)="onFilterCustomers()" [(ngModel)]="filterForm.email"
                  [placeholder]="'enterprise_customer_management.filter.email' | translate">
              </mat-header-cell>
            </ng-container>

            <!-- Tác động -->
            <!-- Setting Column -->
            <ng-container matColumnDef="actionFilter" class="mat-column-symbol">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-bottom"
                style="max-width: 100px;">
              </mat-header-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-header-row style="background: white !important;" [ngClass]="isShowFilter ? '' : 'd-none'"
              *matHeaderRowDef="filterRow"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
        </div>
        <div class="py-4" *ngIf="error">
          <div class="card">
            <p class="card-body text-danger" style="white-space: pre-wrap; padding-bottom: 0;">{{error}}</p>
          </div>
        </div>
        <!-- Pagination -->
        <app-pagination *ngIf="groupCustomerId" [(paginate)]="paginate"
          (pageChange)="onFilterCustomers($event.page, $event.pageSize)">
        </app-pagination>
        <!-- /Pagination -->

      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>

  <!-- Huỷ bỏ & Lưu  -->
  <mat-card-actions class="text-center">
    <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button" appTrackEvent="w.btn.dsnhomkh.them_moi.huy_bo">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>
    <button *ngIf="!groupCustomerId && !this.isSMEHubAccount()" mat-raised-button [disabled]="!isFormChanging && groupName" appTrackEvent="w.btn.dsnhomkh.them_moi.them_nhom_kh"
      (click)="onCreateClick()" color="primary">
      <mat-icon class="mr-0">save</mat-icon>
      {{'button.add_customer_group' | translate}}
    </button>
  </mat-card-actions>
</mat-card>
